export interface AwardsAction {
  type: string;
}

const vehicleAward = (state = {}, action: AwardsAction,) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default vehicleAward;
